import { ffhClient } from './ffh-client';
import type { paths } from '../../types/api/generated';

export type TransferReplacementsData =
  paths['/funnels/transfer-replacements']['post']['responses'][200]['content']['application/json']['data'];

export type TransferReplacementCardPlayer =
  TransferReplacementsData['visible'][number]['player'];

// A hidden IN recommendation (locked) plus the two visible cards, with uplifts
// relative to the out player. The server never returns absolute predicted
// points, so the funnel renders the teaser without leaking predictions.
export const fetchTransferReplacements = async (
  outPlayerId: string,
  squadPlayerIds: string[]
): Promise<TransferReplacementsData> => {
  const { data, error } = await ffhClient().POST(
    '/funnels/transfer-replacements',
    {
      body: { outPlayerId, squadPlayerIds },
      credentials: 'include'
    }
  );

  if (error || !data) {
    const detail = (error as { error?: { message?: string } } | undefined)
      ?.error?.message;
    throw new Error(
      detail
        ? `Failed to load replacements: ${detail}`
        : 'Failed to load replacements'
    );
  }

  return data.data;
};
